import React, { useState, useEffect, useReducer, useRef, useMemo } from "react";
import {
  Tabs,
  Tab,
  Grid,
  Box,
  Card,
  IconButton,
  Button,
  Input,
  InputAdornment,
  Typography,
  Stack,
  Tooltip,
  Menu,
  MenuItem,
  Divider,
  List,
  ListItem,
  Select,
  InputLabel,
  FormControl,
  TextField,
} from "@mui/material";
import dayjs from "dayjs";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { get } from "aws-amplify/api";
import {
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridToolbarColumnsButton,
  GridRowModes,
  GridCellModes,
  useGridApiRef,
} from "@mui/x-data-grid";
import { I18n } from "@aws-amplify/core";
import { GridToolbarExport, GridToolbarFilterButton } from "@mui/x-data-grid";
import ConfirmDeleteDialog from "popup/ConfirmDeleteDialog";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import currentUserToken from "CurrentUserToken";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SearchIcon from "@mui/icons-material/Search";
import { useTheme } from "@mui/material/styles";
import { post } from "aws-amplify/api";
import { APIStatusDialog } from "components/APIStatusDialog";
import EncodeDialog from "popup/EncodeDialog";
import TemplateBox from "components/TemplateBox";
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation
import { useLocation } from "react-router-dom";
import { DataGridPro } from "@mui/x-data-grid-pro/DataGridPro";
import NewAccountAssignationDialog from "popup/NewAccountAssignationDialog";
import EncodingSettingsMenu from "../components/EncodingSettingsMenu";
import PatternSettingsMenu from "../components/PatternSettingsMenu";
import EventHistorySettingsMenu from "../components/EventHistorySettingsMenu";
import { itIT } from "@mui/x-data-grid/locales";
import { deDE } from "@mui/x-data-grid/locales";
import ErrorDialog from "popup/ErrorDialog";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { set } from "date-fns";
import DeleteIcon from "@mui/icons-material/Delete";
import Save from "@mui/icons-material/Save";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimeField } from "@mui/x-date-pickers/TimeField";
import LaunchIcon from "@mui/icons-material/Launch";
import AddIcon from "@mui/icons-material/Add";
import BackspaceIcon from "@mui/icons-material/Backspace";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import DeletePopup from "./deletePopup";
import NotificationPopup from "./notificationPopup";
const COLUMN_VISIBILITY_KEY = "columnVisibility_unrecognized";

const reducer = (lastState, action) => {
  if (action.type === "DATA_RECEIVED") {
    const audit = action.value;
    if (Array.isArray(audit)) {
      audit.forEach((element) => {
        if (typeof element.timestamp === "number") {
          element.timestamp = dayjs(element.timestamp).format(
            "YYYY-MM-DD HH:mm"
          );
        }
      });
      return { audit: audit, fetched: true };
    }
  }
  return lastState;
};

function CalendarFilter() {
  const [state, dispatch] = useReducer(reducer, {
    audit: [],
    fetched: false,
  });
  const [apiStatus, setApiStatus] = useState({
    open: false,
    status: "",
    message: "",
  });
  const apiRef = useGridApiRef();
  const theme = useTheme();
  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "en"
  );
  const [tableParentIsMD, setTableParentIsMD] = useState(false);
  const [languages, setLanguages] = useState([]);
  const toolbarRef = useRef(null);
  const [resizeThrottle, setResizeThrottle] = useState(60);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({});
  const [openMapDialog, setOpenMapDialog] = useState(false);
  const [calendar, setCalendar] = useState("");
  const [rowModesModel, setRowModesModel] = useState({});
  const [cellModesModel, setCellModesModel] = useState({});
  // const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [deletePopupOpen, setDeletePopupOpen] = useState(false);
  const [isAddMode, setIsAddMode] = useState(false);
  const [popUp, setPopUp] = useState({ open: false, message: "", isOk: false });

  const [dropData, setDropData] = useState([]);
  const fetchLists = async () => {
    try {
      const restOperation = get({
        apiName: "TelemonitoringAPI",
        path: "/calendar/info/get",
        options: {
          body: {},
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          queryParams: {},
        },
      });
      const { body } = await restOperation.response;
      const response = await body.json();
      setDropData(response);
      dispatch({ type: "DATA_RECEIVED", value: response });
    } catch (error) {
      console.error("Errore durante la chiamata API:", error);
    }
  };
  // console.log(dropData);
  useEffect(() => {
    fetchLists();
  }, []);

  const [calendar_id, setCalendar_id] = useState("");
  const [dropData2, setDropData2] = useState([]);
  const fetchLists2 = async (calendar_id) => {
    try {
      const restOperation = get({
        apiName: "TelemonitoringAPI",
        path: "/calendar/get",
        options: {
          body: {},
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          queryParams: { calendar_info_id: calendar_id },
        },
      });
      const { body } = await restOperation.response;
      const response = await body.json();
      setDropData2(response);
      dispatch({ type: "DATA_RECEIVED", value: response });
    } catch (error) {
      console.error("Errore durante la chiamata API:", error);
    }
  };

  useEffect(() => {
    if (calendar_id) {
      fetchLists2(calendar_id);
    }
  }, [calendar_id]);

  let genericFormat = {
    id: "",
    day: "",
    start_time: "",
    end_time: "",
  };

  const [formData, setFormData] = useState([
    {
      id: rows.length,
      day: "",
      start_time: "",
      end_time: "",
    },
  ]);

  const [calendarRules, setCalendarRules] = useState([
    {
      calendar: "",
      formData: [
        {
          id: "",
          day: "",
          start_time: "",
          end_time: "",
        },
      ],
    },
  ]);

  useEffect(() => {
    const parentElement = toolbarRef.current;
    if (!parentElement) {
      console.error("toolbarRef is not correctly attached to any DOM element.");
      return;
    }
    const checkSize = (width) => {
      const breakpoint = 960; // 960px is md
      setTableParentIsMD(width < breakpoint);
    };
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        checkSize(entry.contentRect.width);
      }
    });
    resizeObserver.observe(parentElement);
    checkSize(parentElement.offsetWidth);
    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  useEffect(() => {
    if (dropData2 && Array.isArray(dropData2)) {
    }
    setRows(
      dropData2.map((item) => ({
        id: item.id,
        day: item.day,
        start_time: item.start_hour,
        // start_time: item.start_hour.split(":").map(n=>n.padStart(2, "0")).join(":"),
        end_time: item.end_hour,
      }))
    );
  }, [dropData2]);

  useEffect(() => {
    const tlmGetLanguagesAPI = async () => {
      try {
        const restOperation = get({
          apiName: "TelemonitoringAPI",
          path: "/languages",
          options: {
            headers: {
              "Content-Type": "application/json",
              Authorization: `${await currentUserToken()}`,
            },
            queryParams: {},
          },
        });
        const { body } = await restOperation.response;
        const response = await body.json();

        setLanguages(response);
      } catch (error) {
        console.error("Error during the API call:", error);
      }
    };
    tlmGetLanguagesAPI();
  }, []);

  const [columns] = useState([
    {
      field: "day",
      headerName: I18n.get("Day"),
      width: 200,
      editable: true,
      renderCell: (params) => (
        <FormControl fullWidth>
          <Select
            label={I18n.get("Day")}
            value={params.value}
            onChange={(event) =>
              handleCellChange(params.id, "day", event.target.value)
            }
          >
            {dayOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ),
    },
    {
      field: "start_time",
      headerName: I18n.get("Start Time"),
      width: 300,
      editable: true,
      renderCell: (params) => (
        <FormControl fullWidth>
          <Select
            value={params.value || ""}
            name="start_time"
            onChange={(event) => {
              handleCellChange(
                params.id,
                event.target.name,
                event.target.value
              );
            }}
          >
            {timeOptions.map(({ value, label }) => (
              <MenuItem key={value} value={value} disabled={params.row.end_time && value>=params.row.end_time}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ),
    },
    {
      field: "end_time",
      headerName: I18n.get("End Time"),
      width: 300,
      editable: true,
      renderCell: (params) => (
        <FormControl fullWidth>
          <Select
            value={params.value || ""}
            name="end_time"
            
            onChange={(event) => {
              handleCellChange(
                params.id,
                event.target.name,
                event.target.value
              );
            }}
          >
            {timeOptions.map(({ value, label }) => (
              <MenuItem key={value} value={value} disabled={params.row.start_time && value<=params.row.start_time}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ),
    },
    {
      field: "action",
      headerName: I18n.get("Action"),
      resizable: false,
      width: 120,
      renderCell: (params) => {
        return (
          <div>
            {params.row.id !== 0 ? (
              <IconButton
                sx={{
                  width: 30,
                  height: 30,
                  color: "primary.main", // Change color if selected
                }}
                onClick={(event) => {
                  event.stopPropagation();
                  handleRemoveRow(params.row, false);
                }}
              >
                <BackspaceIcon />
              </IconButton>
            ) : (
              ""
            )}

            <IconButton
              sx={{
                width: 30,
                height: 30,
                color: "primary.main", // Change color if selected
              }}
              onClick={(event) => {
                event.stopPropagation();
                handleAddRow(params.row, false);
                // console.log("params.row", params.row);
              }}
            >
              <NoteAddIcon />
            </IconButton>
            <IconButton
              sx={{
                width: 30,
                height: 30,
                color: "primary.main", // Change color if selected
              }}
              onClick={(event) => {
                event.stopPropagation();
                handleDuplicateRow(params.row, false);
              }}
            >
              <FileCopyIcon />
            </IconButton>
          </div>
        );
      },
    },
  ]);

  const handleCellChange = (id, field, value) => {
    // console.log("row prima agg: ", rows);
    setRows((prevRows) =>
      prevRows.map((row) => (row.id === id ? { ...row, [field]: value } : row))
    );
    // console.log("row dopo agg: ", rows);
  };

  const [calendarOptions, setCalendarOptions] = useState([
    // { value: "new", label: I18n.get("New") },
  ]);

  useEffect(() => {
    if (dropData && Array.isArray(dropData)) {
      const formatData = dropData.map((item) => ({
        id: item.id,
        value: item.name,
        label: item.name,
      }));
      setCalendarOptions(formatData);
    }
  }, [dropData]);

  const dayOptions = [
    { value: "Monday", label: I18n.get("Monday") },
    { value: "Tuesday", label: I18n.get("Tuesday") },
    { value: "Wednesday", label: I18n.get("Wednesday") },
    { value: "Thursday", label: I18n.get("Thursday") },
    { value: "Friday", label: I18n.get("Friday") },
    { value: "Saturday", label: I18n.get("Saturday") },
    { value: "Sunday", label: I18n.get("Sunday") },
  ];

  const timeOptions = [];
  for (let hour = 0; hour <= 24; hour++) {
    if (hour !== 24) {
      for (let minute = 0; minute < 60; minute += 10) {
        const time = `${hour.toString().padStart(2, "0")}:${minute
          .toString()
          .padStart(2, "0")}`;
        timeOptions.push({ value: time, label: time });
      }
    } else {
      const time = `${hour.toString().padStart(2, "0")}:00`;
      timeOptions.push({ value: time, label: time });
    }
  }

  const handleAdd = () => {
    if (isAddMode) {
      setCalendar("");
      setCalendar_id("");
      setFormData({
        calendar_name: "",
        calendar_description: "",
      });

      const maxRowId =
        rows.length > 0 ? Math.max(...rows.map((row) => Number(row.id))) : 0;
      const maxDropDataId =
        dropData.length > 0
          ? Math.max(...dropData.map((item) => Number(item.id)))
          : 0;
      let newId = Math.max(maxRowId, maxDropDataId) + 1;
      while (dropData.some((item) => item.id === newId.toString())) {
        newId++;
      }

      const newRow = {
        id: newId,
        day: "",
        start_time: "",
        end_time: "",
      };
      setRows([newRow]); //(prevRows) => [...prevRows, newRow] aggiungeva righe senza cancellare le altre
      return;
    }
    setCalendar("");
    setCalendar_id("");
    const maxRowId =
      rows.length > 0 ? Math.max(...rows.map((row) => Number(row.id))) : 0;
    const maxDropDataId =
      dropData.length > 0
        ? Math.max(...dropData.map((item) => Number(item.id)))
        : 0;
    let newId = Math.max(maxRowId, maxDropDataId) + 1;
    while (dropData.some((item) => item.id === newId.toString())) {
      newId++;
    }

    const newRow = {
      id: newId,
      day: "",
      start_time: "",
      end_time: "",
    };
    setRows([newRow]);
    setFormData({ calendar_name: "", calendar_description: "" });
    setIsAddMode(true);
  };

  const handleAddRow = (row) => {
    //setRows([...rows, { id: rows.length + 1, day: "", start_time: "", end_time: "" }])
    setRows((prevRows) => [
      ...prevRows,
      { id: prevRows.length + 1, day: "", start_time: "", end_time: "" },
    ]);
  };

  const handleDuplicateRow = (row) => {
    setRows((prevRows) => [
      ...prevRows,
      {
        id: prevRows.length + 1,
        day: row.day,
        start_time: row.start_time,
        end_time: row.end_time,
      },
    ]);
  };

  const handleRemoveRow = (id) => {
    setRows((prevRows) => {
      if (prevRows.length === 1) {
        return prevRows;
      }
      return prevRows.filter((row) => row.id != id.id);
    });
  };

  const handleChange = (event) => {
    // console.log("event: ", event.target.field);
    setFormData((currentState) => ({
      ...currentState,
      [event.target.field]: event.target.value,
    }));
    // console.log("formData", formData);
  };

  const handleCalendarChange = (event) => {
    const selectedName = event.target.value;
    setCalendar(selectedName);
    setCalendarRules({ ["calendar"]: event });
    if (isAddMode) {
      setIsAddMode(false);
    }
    const selectedData = dropData.find(
      (item) =>
        item.name.toLowerCase().trim() === selectedName.trim().toLowerCase()
    );

    if (selectedData) {
      setCalendar_id(selectedData.id);
      setFormData((prev) => ({
        ...prev,
        calendar_description: selectedData.description || "",
      }));
    }
    // console.log("calendarRules", calendarRules);
  };

  const validateRows = () => {
    if (isAddMode) {
      for (let row of rows) {
        if (
          !row.day ||
          !row.start_time ||
          !row.end_time ||
          formData.calendar_name === ""
        ) {
          setPopUp({
            open: true,
            message: `${I18n.get("All fields must be filled out")}`,
            isOk: false,
          });
          return false;
        }
      }
    } else {
      for (let row of rows) {
        if (!row.day || !row.start_time || !row.end_time) {
          setPopUp({
            open: true,
            message: `${I18n.get("All fields must be filled out")}`,
            isOk: false,
          });
          return false;
        }
      }
    }
    return true;
  };
  const validateCalendarName = (name) => {
    const nameExists = dropData.some(
      (item) => item.name.toLowerCase() === name.toLowerCase()
    );
    if (nameExists) {
      setPopUp({
        open: true,
        message: "This name already exists",
        isOk: false,
      });
      return false;
    }
    return true;
  };

  const handleSaveCalendar = async () => {
    if (!isAddMode) return;
    if (!validateCalendarName(formData.calendar_name)) return;
    if (!validateRows()) return;
    const payload = {
      name: formData.calendar_name.toLowerCase() || "",
      description: formData.calendar_description || "",
      calendar: rows.map((row) => ({
        day: row.day || "",
        start_hour: row.start_time || "",
        end_hour: row.end_time || "",
      })),
    };
    try {
      const restOperation = post({
        apiName: "TelemonitoringAPI",
        path: "/calendar/new",
        options: {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          queryParams: {},
          body: payload,
        },
      });
      const { body } = await restOperation.response;
      const response = await body.json();
      if (response === "ok") {
        setPopUp({
          open: true,
          message: `${I18n.get("The calendar has been successfully created")}`,
          isOk: true,
        });
        setIsAddMode(false);
        setCalendar("");
        setRows([]);
        fetchLists();
      } else {
        setPopUp({
          open: true,
          message: `${I18n.get("An error occurred while saving the calendar")}`,
          isOk: false,
        });
        console.error("errore ", response);
      }
    } catch (error) {
      console.error("errore salvataggio:", error);
    }
  };

  const tlmPostDeleteCalendar = async (calendar_id) => {
    if (calendar_id) {
      try {
        const restOperation = get({
          apiName: "TelemonitoringAPI",
          path: "/calendar/delete",
          options: {
            body: {},
            headers: {
              "Content-Type": "application/json",
              Authorization: `${await currentUserToken()}`,
            },
            queryParams: { calendar_info_id: calendar_id },
          },
        });
        const { body } = await restOperation.response;
        const response = await body.json();
        setCalendar_id("");
        setCalendar("");
        setRows([]);
        fetchLists();
        dispatch({ type: "DATA_RECEIVED", value: response });
        setPopUp({
          open: true,
          message: `${I18n.get("The calendar has been successfully deleted")}`,
          isOk: true,
        });
      } catch (error) {
        setPopUp({
          open: true,
          message: `${I18n.get(
            "An error occurred while deleting the calendar"
          )}`,
          isOk: false,
        });
        console.error("Errore durante la chiamata API:", error);
      }
    } else {
      // console.log("nessun calendario selezionato");
    }
  };

  const handleUpdateCalendar = async (calendar_id) => {
    if (!validateRows()) return;
    if (calendar_id) {
      const selectedCalendar =
        dropData.find((item) => String(item.id) === String(calendar_id)) || {};

      const description = formData.calendar_description || "";
      const payload = {
        description,
        calendar: rows.map((row) => ({
          day: row.day || "",
          start_hour: row.start_time || "",
          end_hour: row.end_time || "",
        })),
      };
      try {
        const restOperation = post({
          apiName: "TelemonitoringAPI",
          path: "/calendar/edit",
          options: {
            headers: {
              "Content-Type": "application/json",
              Authorization: `${await currentUserToken()}`,
            },
            queryParams: { calendar_info_id: calendar_id },
            body: payload,
          },
        });
        const { body } = await restOperation.response;
        const response = await body.json();
        if (response === "ok") {
          setPopUp({
            open: true,
            message: `${I18n.get(
              "The calendar has been successfully updated"
            )}`,
            isOk: true,
          });
          setCalendar_id("");
          setCalendar("");
          setRows([]);
          fetchLists();
        } else {
          setPopUp({
            open: true,
            message: `${I18n.get(
              "An error occurred while updating the calendar"
            )}`,
            isOk: false,
          });
          console.error("errore ", response);
        }
      } catch (error) {
        console.error("errore salvataggio:", error);
      }
    } else {
      setPopUp({
        open: true,
        message: `${I18n.get("No calendar selected")}`,
        isOk: false,
      });
      // console.log("errore nell'aggiornamento, manca calendar_id");
    }
  };

  const handleDeleteCalendar = () => {
    setDeletePopupOpen(true);
    // setCalendarOptions(calendarOptions.filter((option) => option.value !== calendar));
    // setCalendarRules(calendarRules.filter((rule) => rule.calendar !== calendar));
  };

  const processRowUpdate = (newRow, oldRow) => {
    const updatedRow = { ...newRow, isNew: false };
    const currentRows = rows.map((row) =>
      row.id === oldRow.id ? updatedRow : row
    );
    setRows(currentRows);

    const updatedFormData = { ...genericFormat, ...newRow };
    updatedFormData["id"] = newRow.id;
    delete updatedFormData["isNew"];

    setFormData(
      formData.map((row) => (row.id === oldRow.id ? updatedFormData : row))
    );

    return updatedRow;
  };
  const selectedCalendarData = dropData.find(
    (item) => item.name.toLowerCase().trim() === calendar.toLowerCase().trim()
  );
  const description = selectedCalendarData?.description || "";
  const renderToolbar = () => {
    return (
      <div ref={toolbarRef}>
        <Stack direction="column" spacing={2} sx={{ mb: 2 }}>
          <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
            {" "}
            <Typography variant="h5" mt={0.5} mb={1}>
              {I18n.get("Calendar Filter")}
            </Typography>
          </Stack>
          <Stack display="flex" direction="row" spacing={2}>
            <Button
              onClick={handleAdd} // Open the pop-up
              color="primary"
              variant="outlined"
              startIcon={<AddIcon />}
              fullWidth={tableParentIsMD}
            >
              {I18n.get("Create new calendar")}
            </Button>
            <FormControl
              fullWidth
              margin="normal"
              className="custom-form-control"
            >
              <InputLabel>{I18n.get("Calendar")}</InputLabel>
              <Select
                label={I18n.get("Calendar")}
                value={calendar}
                onChange={handleCalendarChange}
                name="calendar"
                renderValue={(selected) => selected.toLowerCase()}
              >
                {dropData.map((item) => (
                  <MenuItem key={item.id} value={item.name}>
                    {item.name.toLowerCase()}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {calendar !== undefined ? (
              <>
                <Button
                  onClick={
                    isAddMode
                      ? handleSaveCalendar
                      : () => handleUpdateCalendar(calendar_id)
                  } // Open the pop-up
                  color="primary"
                  variant="outlined"
                  startIcon={<Save />}
                  sx={{ minWidth: "96px" }}
                  disabled={rows.length === 0}
                >
                  {I18n.get("Save")}
                </Button>

                <Button
                  onClick={() => setDeletePopupOpen(true)} // Open the pop-up
                  color="primary"
                  variant="outlined"
                  startIcon={<DeleteIcon />}
                  sx={{ minWidth: "96px" }}
                  disabled={isAddMode || !calendar}
                >
                  {I18n.get("Delete")}
                </Button>
              </>
            ) : (
              ""
            )}
          </Stack>
          <Stack direction="row" spacing={2}>
            {isAddMode ? (
              <FormControl
                fullWidth
                margin="normal"
                className="custom-form-control"
              >
                <TextField
                  label={I18n.get("Name")}
                  value={formData.calendar_name}
                  onChange={(e) =>
                    setFormData((currentState) => ({
                      ...currentState,
                      ["calendar_name"]: e.target.value,
                    }))
                  }
                  margin="normal"
                  name="calendar_name"
                  required
                  className="custom-text-field"
                />
                <TextField
                  label={I18n.get("Description")}
                  value={formData.calendar_description}
                  onChange={(e) =>
                    setFormData((currentState) => ({
                      ...currentState,
                      ["calendar_description"]: e.target.value,
                    }))
                  }
                  margin="normal"
                  name="calendar_description"
                  className="custom-text-field"
                />
              </FormControl>
            ) : (
              ""
            )}
            {!isAddMode && calendar ? (
              <TextField
                label={I18n.get("Description")}
                value={formData.calendar_description || ""}
                // inputProps={{readOnly:!!description}} //se description è una stringa vuota allora è editabile, altrimenti no
                // inputProps={{readOnly:true}}
                // disabled={!description} //rende il campo non modificabile a prescindere
                // sx={{cursor: "pointer"}}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    calendar_description: e.target.value,
                  }))
                }
                margin="normal"
                name="calendar_description"
                className="custom-text-field"
                fullWidth
              />
            ) : (
              ""
            )}
          </Stack>
        </Stack>
        {deletePopupOpen && (
          <DeletePopup
            open={deletePopupOpen}
            onClose={() => setDeletePopupOpen(false)}
            onSubmit={() => tlmPostDeleteCalendar(calendar_id)}
          />
        )}
        <NotificationPopup
          open={popUp.open}
          onClose={() => setPopUp({ ...popUp, open: false })}
          message={popUp.message}
          isOk={popUp.isOk}
        />
      </div>
    );
  };

  function getBrowserName() {
    const userAgent = navigator.userAgent;
    if (userAgent.includes("Firefox")) {
      return "Firefox";
    } else if (userAgent.includes("Edg")) {
      return "Edge";
    } else if (userAgent.includes("Chrome")) {
      return "Chrome";
    }
  }
  const browser = getBrowserName();
  function getScreenDimension() {
    const screenHeight = window.screen.height;
    if (screenHeight >= 1440) {
      return "27inches";
    } else if (screenHeight >= 1080) {
      return "24inches";
    }
  }

  const [tableHeight, setTableHeight] = useState(0);

  useEffect(() => {
    const updateHeight = () => {
      const navbarHeight = document.getElementById("navbar");
      const footerHeight = document.getElementById("footer");
      const margin =
        browser === "Firefox" ? 200 : browser === "Chrome" ? 200 : 200;
      const availableHeight =
        document.documentElement.clientHeight -
        navbarHeight -
        footerHeight -
        margin;
      setTableHeight(availableHeight);
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  useEffect(() => {
    document.body.style.overflow = "hidden";
  }, []);
  const darkMode = localStorage.getItem("darkMode") === "true";
  return (
    <>
      <DashboardLayout>
        <DashboardNavbar
          absolute
          light
          language={language}
          setLanguage={setLanguage}
        />
        <Stack
          direction="row"
          spacing={1}
          sx={{ ml: 3, mt: 3, width: "400px" }}
        >
          <EncodingSettingsMenu />
          <PatternSettingsMenu />
          <EventHistorySettingsMenu />
        </Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box sx={{ p: 2, maxHeight: `${tableHeight}px` }}>
              {" "}
              <Card
                sx={{
                  p: 3,
                  maxHeight: `${tableHeight}px`,
                  overflow: "auto",
                }}
              >
                {renderToolbar()}
                {calendar === undefined ? (
                  ""
                ) : (
                  <DataGridPro
                    sx={{
                      "& .MuiDataGrid-root, & .MuiDataGrid-footerContainer": {
                        minHeight: "2rem",
                      },
                      "&  .MuiDataGrid-cell ": {
                        cursor: "default",
                      },
                      borderColor: darkMode ? "#6B635A" : "",
                      "& .MuiDataGrid-cell, &.MuiDataGrid-columnHeaders": {
                        borderColor: darkMode ? "#625a52" : "",
                      },
                      "& .MuiDataGrid-columnSeparator": {
                        borderColor: darkMode ? "#625a52" : "",
                      },
                      "--DataGrid-rowBorderColor": darkMode ? "#625a52" : "",
                      minHeight: "40vh",
                      flexFlow: 1,
                      height: "100%",
                    }}
                    localeText={
                      language === "it"
                        ? itIT.components.MuiDataGrid.defaultProps.localeText
                        : language === "ge"
                        ? deDE.components.MuiDataGrid.defaultProps.localeText
                        : ""
                    }
                    // onCellDoubleClick={(params, event) => {
                    //   // Prevent the default double-click behavior
                    //   event.defaultMuiPrevented = true;
                    // }}

                    editMode="row"
                    rows={rows}
                    columns={columns}
                    getRowId={(row) => row.id}
                    apiRef={apiRef}
                    rowHeight={70}
                    autoPageSize
                    disableAutosize
                    disableSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                    hideFooterPagination
                    hideFooterRowCount
                    hideFooter
                    processRowUpdate={processRowUpdate}
                  />
                )}

                <ErrorDialog
                  open={errorDialogOpen}
                  onClose={() => setErrorDialogOpen(false)}
                  message={errorMessage}
                />
                <APIStatusDialog
                  open={apiStatus.open}
                  status={apiStatus.status}
                  message={apiStatus.message}
                />
              </Card>
            </Box>
          </Grid>
        </Grid>
      </DashboardLayout>
    </>
  );
}
export default CalendarFilter;
